// The buttons sheets end with, as style objects for the sheets that still set
// their layout inline. They mirror the .ml-btn classes in styles/base.css
// (ux/03 Buttons): primary = --ml-primary-*, secondary = hairline, radius 10,
// bold tracked caps. New code uses the classes. Both are full width and stack.

const btn: React.CSSProperties = {
  minHeight: 48, padding: '0 18px', borderRadius: 'var(--ml-radius-button)',
  fontSize: 13, fontWeight: 700, letterSpacing: 'var(--ml-label-tracking)', textTransform: 'uppercase',
  cursor: 'pointer', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 8,
}

/** The full-width button a sheet closes with — "Done", "Got it". */
export const wideBtn: React.CSSProperties = {
  ...btn, width: '100%', border: '1px solid var(--ml-separator)', background: 'transparent', color: 'var(--ml-text)',
}

/**
 * The full-width submit above them, dimmed until the form is valid. Takes
 * the predicate rather than `disabled` so the look and the cursor can't
 * disagree with the button's own disabled state.
 */
export function wideSubmitBtn(enabled: boolean): React.CSSProperties {
  return {
    ...btn, width: '100%', border: 'none', marginBottom: 10,
    background: 'var(--ml-primary-bg)', color: 'var(--ml-primary-fg)',
    opacity: enabled ? 1 : 0.4, cursor: enabled ? 'pointer' : 'default',
  }
}
